<template>
  <div
    class="card mb-5 mb-xl-10"
    id="profile_details_view"
  >
    <EditCompanyDetail
      :companyId="companyId"
      :company="company"
    />
    <!--begin::Card header-->
    <div class="card-header">
      <!--begin::Card title-->
      <div class="card-title m-0">
        <h3 class="fw-bolder m-0 fs-4 text-gray-800">
          {{ translate("Details") }}
        </h3>
      </div>
    </div>
    <div class="card-body p-9">
      <div class="row">
        <h5 class="d-flex align-items-start flex-column text-gray-700">
          {{ company.Name }}
          <span class="text-muted fw-bold fs-7">{{ company.Description }}</span>
        </h5>
      </div>

      <div class="row mt-3">
        <h6 class="d-flex align-items-start flex-column text-gray-700">
          {{ translate("company_detail_label_contact_info") }}
          <span class="text-gray-600 fw-bold fs-7 mt-1"
            >{{ company.Email + " - " + company.PhoneNumber }}
          </span>
          <span class="text-gray-500 fw-bold fs-7 mt-1"
            >{{ company.Firstname + "  " + company.Lastname }}
          </span>
        </h6>
      </div>

      <div class="row mt-3">
        <h6 class="d-flex align-items-start flex-column text-gray-700">
          {{ translate("Address") }}
          <span
            v-show="company.CountryName !== null"
            class="text-gray-600 fw-bold fs-7 mt-1"
            >{{ company.CountryName + " - " + company.CityName }}
          </span>
          <span
            v-show="company.Address !== null"
            class="text-gray-500 fw-bold fs-7 mt-1"
            >{{ company.Address + " / " + company.DistrictName }}
          </span>
        </h6>
      </div>

      <div class="row mt-3">
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-primary btn-sm"
            data-bs-toggle="modal"
            data-bs-target="#edit-company-profile-modal"
          >
            {{ translate("Edit") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue";
import { useI18n } from "vue-i18n";
import EditCompanyDetail from "@/components/Admin/Company/Modal/EditCompanyDetail.vue";
const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const company = inject("company");
const companyId = inject("company_id");
</script>

<style></style>
